import { defineStore } from "pinia";

export const useAppStore = defineStore("app", {
  state: () => ({
    needsRemount: false, // Flag to force remount only once
    justLogin: false, // Flag to indicate if the user just logged in
  }),
  actions: {
    triggerRemount() {
      this.needsRemount = true;
    },
    resetRemount() {
      this.needsRemount = false;
    },
    setJustLogin(value) {
      this.justLogin = value;
    },
    getJustLogin() {
      return this.justLogin;
    }
  },
  persist: true,
});